import { useInView } from 'react-intersection-observer';

const LazyLoadingBlock=({children,customStyles})=>{
    const { ref, inView } = useInView({
        triggerOnce: true, // Ensures the children are only rendered once when in view
        threshold: 0.1,    // Adjust this to determine when the element is considered "in view"
    });

    return (
        <div ref={ref} className={``}>
                {inView ? children : <span className={`${customStyles?customStyles:``}`}>Loading...</span>}
        </div>
    );
}

export default LazyLoadingBlock;